import { useLinked, useModel } from "@type-r/react";
import React from "react";
import { CustomerReferenceDataObject } from "../../api/customerReferenceData";
import { AssetsSection } from "../assets-section";
import { InblockedAssetsDataStep } from "../inblocked-assets-data-step";
import { InblockedAssetsTitle } from "../inblocked-assets-title";
import { CustomerReferenceDataTile } from "./customer-reference-data-tile";
import { CustomerReferenceDataExternalSystems } from "./externalSystems";

export const InblockedCustomerReferenceDataStep = ({ job, back, $assetTypeSelect, assetTypeMultiOptions, $refreshEvents }: { job, back?, $assetTypeSelect?, assetTypeMultiOptions?, $refreshEvents}) => {
    const customerReferenceDataChanges = useModel(CustomerReferenceDataObject);
    const selectedCustomerReferenceDataChanges = useModel(CustomerReferenceDataObject);
    const $activeInvoice = useLinked(null);
    const $filter = useLinked({ search: '', eventType: null });
    const $loadedAssetEvents = useLinked(false);

    const $selectAllAssets = useLinked(false);

    return <InblockedAssetsDataStep
        assetName='Customer Reference Data'
        assetChanges={customerReferenceDataChanges}
        selectedAssets={selectedCustomerReferenceDataChanges}
        $filter={$filter}
        job={job}
        back={back}
        $loadedAssetEvents={$loadedAssetEvents}
        assetsListComponent={
            (filteredAssetChanges, itemsCount, $selectAllAssets, assetEventsGeneralCount) =>
                <AssetsSection
                    height={420}
                    title={<InblockedAssetsTitle assetChanges={customerReferenceDataChanges.items} externalSystems={CustomerReferenceDataExternalSystems} $filter={$filter} $loadedAssetEvents={$loadedAssetEvents} importJobId={job.importJobId} itemsCount={itemsCount} assetEventsGeneralCount={assetEventsGeneralCount} />}
                    assets={filteredAssetChanges}
                    assetTile={CustomerReferenceDataTile}
                    notExpanded={false}
                    $active={$activeInvoice}
                    selected={selectedCustomerReferenceDataChanges.items}
                    selectAllAssets={$selectAllAssets} />
        }
        externalSystems={CustomerReferenceDataExternalSystems}
        $assetTypeSelect={$assetTypeSelect}
        assetTypeMultiOptions={assetTypeMultiOptions} 
        $refreshEvents={$refreshEvents}/>
};
